<template>
  <div class="general-wrapper">
    <Header>
      <template #title>
        <h4 class="qrw-heading-md">QRStore </h4>
         <span class="c-grey pl-2">
           | {{ isHotel ? "for hotels" : "for cafes" }}
        </span>
      </template>
      <template #actions>
        <DashboardButton
          @click="$router.push('/subscription_history')"
          variant="black"
          >{{ $t("tables.payments_history") }}</DashboardButton
        >
      </template>
    </Header>
   
      <!-- <router-link
        tag="div"
        :to="'/' + $route.query.refsys"
        class="go-back"
        v-if="$route.query.refsys"
      ></router-link> -->
      
 
    <!-- <div class="center-container px-50">
      <SystemsStoreCard
        type="inside"
        @subscribe="(v) => (buy_subscription = v)"
        @changeCard="onChangeCard"
        @cancel="(v) => (to_cancel_subscription = v)"
        v-if="canShowModeCard('inside')"
      />
      <SystemsStoreCard
        type="preorder"
        image="preorder"
        @subscribe="(v) => (buy_subscription = v)"
        @changeCard="onChangeCard"
        @cancel="(v) => (to_cancel_subscription = v)"
        v-if="canShowModeCard('preorder')"
      />
      <SystemsStoreCard
        type="delivery"
        image="delivery"
        @subscribe="(v) => (buy_subscription = v)"
        @changeCard="onChangeCard"
        @cancel="(v) => (to_cancel_subscription = v)"
        v-if="canShowModeCard('delivery')"
      />
      <SystemsStoreCard
        type="reserve"
        @subscribe="(v) => (buy_subscription = v)"
        @changeCard="onChangeCard"
        @cancel="(v) => (to_cancel_subscription = v)"
        image="reserve"
        v-if="canShowModeCard('reserve')"
      />

      <SystemsStoreCard
        type="hotels"
        @cancel="(v) => (to_cancel_subscription = v)"
        @subscribe="(v) => (buy_subscription = v)"
        @changeCard="onChangeCard"
        image="rooms"
        v-if="canShowModeCard('hotels')"
      />

      <SystemsStoreCard
        type="pro"
        @cancel="(v) => (to_cancel_subscription = v)"
        @subscribe="(v) => (buy_subscription = v)"
        @changeCard="onChangeCard"
        image="pro"
        v-if="!canShowModeCard('hotels')"
      />
    </div> -->

    <ConfirmModal
      @confirm="cancelSubscription"
      @cancel="to_cancel_subscription = null"
      v-if="to_cancel_subscription"
      >{{ $t("subscription.cancel") }}</ConfirmModal
    >

    <div class="qrstore-systems-list">
      <StoreCard
        v-for="mode in modes"
        :key="mode"
        :mode="mode"
        @cancel="(v) => (to_cancel_subscription = v)"
        @subscribe="(v) => (buy_subscription = v)"
        @changeCard="onChangeCard"
      />
    </div>

    <PopUp
      @close="buy_subscription = null"
      v-if="buy_subscription"
      v-show="!changing_card"
      :title="$t('subscribe_period.title')"
    >
      <div>
        <div class="subscription-pop-up-container">
          <SubscriptionPriceCard
            @select="selected_periodicity = 'month'"
            :active="selected_periodicity == 'month'"
            :length="1"
            @subscribe="proceedToPayment"
            :profit="0"
            :month_price="buy_subscription.price"
          />
          <SubscriptionPriceCard
            @select="selected_periodicity = 'year'"
            :month_price="Math.round(buy_subscription.price * 0.8)"
            :active="selected_periodicity == 'year'"
            @subscribe="proceedToPayment"
            :profit="Math.round(buy_subscription.price * 12 * 0.2)"
            :length="12"
          />
        </div>
      </div>

      <form
        method="POST"
        action="https://www.liqpay.ua/api/3/checkout"
        accept-charset="utf-8"
        ref="subscribeForm"
        v-if="subscribe_form"
      >
        <input type="hidden" name="data" :value="subscribe_form.data" />
        <input
          type="hidden"
          name="signature"
          :value="subscribe_form.signature"
        />
      </form>
    </PopUp>
  </div>
</template>
<script>
import SystemsStoreCard from "@/components/SystemsStoreCard.vue";
import DashboardButton from "@/components/DashboardButton.vue";
import PopUp from "@/components/PopUp.vue";
import SubscriptionPriceCard from "@/components/subscriptions/SubscriptionPriceCard.vue";
import StoreCard from "@/components/subscriptions/StoreCard.vue";

import ConfirmModal from "@/components/modals/ConfirmModal.vue";

import SubscriptionAPI from "@/api/subscription";

export default {
  components: {
    SystemsStoreCard,
    DashboardButton,
    PopUp,
    SubscriptionPriceCard,
    ConfirmModal,
    StoreCard,
  },
  data() {
    return {
      popup: false,

      to_cancel_subscription: null,
      buy_subscription: null,
      changing_card: false,

      selected_periodicity: "month",

      subscribe_form: null,
    };
  },
  watch: {
    popup() {
      if (this.popup) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    },
  },
  methods: {
    canShowModeCard(mode) {
      const is_available = this.$store.getters["worldwide/checkSystem"](mode);

      const is_hotel = this.$store.getters.isHotel;

      if (is_hotel) {
        return is_available && mode == "hotels";
      } else {
        return is_available && mode != "hotels";
      }
    },
    cancelSubscription() {
      SubscriptionAPI.cancelSubscription(this.to_cancel_subscription._id)
        .then((data) => {
          this.$store.commit("subscriptions/setSingleSubscription", {
            mode: this.to_cancel_subscription.mode,
            subscription: data.subscription,
          });

          this.to_cancel_subscription = null;
        })
        .catch((error) => {
          this.$store.dispatch("showError", "subscription_error");
          this.to_cancel_subscription = null;
        });
    },
    onChangeCard(subscription) {
      this.buy_subscription = subscription;
      this.changing_card = true;
      this.selected_periodicity = this.buy_subscription.periodicity;

      this.proceedToPayment();
    },
    proceedToPayment() {
      SubscriptionAPI.generateForm(
        this.buy_subscription._id,
        this.selected_periodicity,
        this.changing_card
      )
        .then((data) => {
          this.subscribe_form = data.form;

          this.$nextTick(() => {
            this.$refs.subscribeForm.submit();
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "subscription_error");
        });
    },
  },
  computed: {
    isHotel() {
      return this.$store.getters.isHotel;
    },
    modes() {
      return ["preview", "delivery", "preorder", "inside", "reserve", "pro"];
    },
  },
};
</script>
<style scoped>
.subscription-pop-up-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin-top: 5.555555555555555vh;
}

.qrstore-systems-list {
  padding: 24px 40px;
  overflow: auto;
  width: 100%;
}
</style>
